import {DefaultPluginConfig, PluginConfig, PluginConfigPosition, registerPlugin} from "../lib/plugin";

interface ImageConfig extends DefaultPluginConfig, PluginConfigPosition {
    image: string
    width: number
}

const render = (id: string, config: any, parentNode: HTMLElement|null = null) => {
    if (!parentNode) {
        parentNode = document.body
    }

    if (typeof document === 'undefined') {
        return
    }
    if (!config.image) {
        return
    }
    // @ts-ignore
    let field: HTMLImageElement = document.getElementById('plugin--image--' + id)
    if (field) {
        field.parentNode.removeChild(field)
    }

    if (!config.image.trim()) {
        return
    }

    if (!config.enabled) {
        return
    }

    field = document.createElement('img')
    field.src = '/file/' + config.image
    field.id = 'plugin--image--' + id
    field.style.position = 'absolute'
    field.style.width = `${config.width}px`

    if (config.horizontal === 'left') {
        field.style.left = `${config.horizontalSpace}px`
    } else {
        field.style.right = `${config.horizontalSpace}px`
    }

    if (config.vertical === 'top') {
        field.style.top = `${config.verticalSpace}px`
    } else {
        field.style.bottom = `${config.verticalSpace}px`
    }

    parentNode.appendChild(field)
}

registerPlugin<ImageConfig>('image', 'Image', {
    defaultSettings: [ "enabled", "image" , "horizontal", "vertical", "horizontalSpace", "verticalSpace" ],

    supports: ['position'],

    settings: {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true,
        },
        image: {
            title: 'image',
            type: 'image',
            defaultValue: '',
        },
        width: {
            title: 'Width',
            type: 'number',
            defaultValue: 300,
        },
    },

    initialize: (id, config, parentNode = null) => {
        console.log('image plugin init', id, config, parentNode)
        render(id, config, parentNode)
    },

    onConfig: (id, config: PluginConfig<ImageConfig>) => {
        console.log('image plugin config', id, config)
        render(id, config)
    },

    onRemove: (id) => {
        console.log('removing image plugin', id)
        let field = document.getElementById('plugin--image--' + id)
        if (field) {
            field.parentNode.removeChild(field)
        }
    },

    onWsAction: () => false
})